<template>
  <div class="create-acivity">
    <div class="acivity-right">
      <div style="width: 80%; height: 100%;">
        <div class="tab-tit">
          <ul>
            <li @click="curId = 0" :class="{'cur' : curId >= 0}" style="width:60px">
              <img src="../../assets/images/activity_tab1.png">
              <p>基础设置</p>
            </li>
            <li @click="curId = 1" :class="{'cur' : curId >= 1}">
              <img src="../../assets/images/activity_tab2.png" v-if="curId >= 1">
              <img src="../../assets/images/activity_tab2_1.png" v-else>
              <span></span>
              <p>奖项配置</p>
            </li>
            <li @click="curId = 2" :class="{'cur' : curId >= 2}">
              <img src="../../assets/images/activity_tab3.png" v-if="curId >= 2">
              <img src="../../assets/images/activity_tab3_1.png" v-else>
              <span></span>
              <p style="width: 250px;">活动策略</p>
            </li>
          </ul>
        </div>
        <div v-if="curId === 0" class="setting-content">
          <div class="new_name">基础设置</div>
          <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="100px">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="formInline.name" placeholder="请输入活动名称（不能超过50字）" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item prop="date" label="活动时间">
              <el-date-picker
                v-model="formInline.time"
                @change="dateChange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="date" label="活动说明">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="formInline.textarea">
              </el-input>
            </el-form-item>
            <el-form-item label="关联公众号" prop="description">
              <el-select v-model="formInline.public_id" placeholder="请选择">
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源" prop="description">
              <el-select v-model="formInline.source_id" placeholder="请选择">
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="date" label="来源说明">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="formInline.sources">
              </el-input>
            </el-form-item>
          </el-form>
          <div
            class="new_name"
            @click="basicSenior = !basicSenior">
            高级选项
            <i :class="{'el-icon-caret-bottom': !basicSenior, 'el-icon-caret-top': basicSenior}">
            </i>
          </div>
          <el-form v-if="basicSenior" :inline="false" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="100px">
            <el-form-item label="强制关注">
              <el-radio-group v-model="formInline.draw_type">
                <el-radio :label="1">关闭</el-radio>
                <el-radio :label="0">开启</el-radio>
              </el-radio-group>
              <p style="color: #666;" v-if="formInline.draw_type === 1">可直接参加活动，活动抽奖后再关注微信公众号领奖</p>
              <p style="color: #666;" v-if="formInline.draw_type === 0">进入活动前，需先关注微信公众号</p>
            </el-form-item>
            <el-form-item label="是否微信分享">
              <el-radio-group v-model="formInline.wechat_share" @change="wechatShareChange">
                <el-radio :label="0">禁止分享</el-radio>
                <el-radio :label="1">允许分享</el-radio>
              </el-radio-group>
              <div v-if="formInline.wechat_share === 1" class="cover_img">
                <el-upload
                  class="avatar-uploader"
                  name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                  <img v-if="formInline.share_img" :src="formInline.share_img" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p style="margin:0 8px;line-height:20px;margin-bottom:8px;">请上传jpg,png格式的图片</p>
                <el-form-item label="标题"  label-width="50px" style="padding-left:0">
                  <el-input class="title-input-1" v-model="formInline.share_title" placeholder="25字以内" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item label="描述" label-width="50px" style="padding-left:0">
                  <el-input v-model="formInline.share_description" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="50字以内" maxlength="50" style="width:245px;"></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="邀请好友助力">
              <el-radio-group v-model="formInline.assistance_status" @change="assistanceStatusChange">
                <el-radio :disabled="formInline.wechat_share === 0" :label="2">关闭</el-radio>
                <el-radio :disabled="formInline.wechat_share === 0" :label="1">开启</el-radio>
              </el-radio-group>
              <p class="wechat_share" v-if="formInline.assistance_status === 1">
                每参加一场活动，成功邀请一位好友助力，当天将额外获得一次抽奖机会<br>单场活动最多获得机会
                <el-input-number v-model="formInline.everyactivity_assistance_prize_num" controls-position="right" :min="1" style="width:101px;margin-bottom: 5px;" :disabled="formInline.wechat_share === 0"></el-input-number>
                次<br>每天最多获得机会
                <el-input-number v-model="formInline.everyday_assistance_prize_num" controls-position="right" :min="1" style="width:101px;" :disabled="formInline.wechat_share === 0"></el-input-number>
                次
              </p>
            </el-form-item>
            <el-form-item label="为好友助力">
              <el-radio-group
                v-model="formInline.assistance_prize_status">
                <el-radio
                  :disabled="formInline.wechat_share === 0 ||
                  formInline.assistance_status === 2"
                  :label="0">
                  无奖励
                </el-radio>
                <el-radio
                  :disabled="formInline.wechat_share === 0 ||
                  formInline.assistance_status === 2"
                  :label="1">
                  助力奖励
                </el-radio>
              </el-radio-group>
              <p
                class="wechat_share"
                v-if="formInline.assistance_prize_status === 1">为好友助力后可同时获得抽奖机会一次
                <br>
                每人每天可为同一好友助力
                <el-input-number
                  v-model="formInline.everyday_assistance_one_num"
                  controls-position="right"
                  :min="1"
                  style="width:101px;margin-bottom: 5px;"
                  :disabled="formInline.wechat_share === 0 ||
                  formInline.assistance_status === 2 ||
                  formInline.assistance_prize_status === 0">
                  </el-input-number>
                  次<br>每天最多助力
                <el-input-number
                  v-model="formInline.everyday_assistance_num"
                  controls-position="right"
                  :min="1"
                  style="width:101px"
                  :disabled="formInline.wechat_share === 0 ||
                  formInline.assistance_status === 2 ||
                  formInline.assistance_prize_status === 0">
                </el-input-number>次
              </p>
            </el-form-item>
          </el-form>
          <div style="text-align: center;width: 260px;margin: 0 auto;height: 36px">
            <el-button class="dialog-confirm-btn" type="primary" style="float: left; margin-bottom: 30px;" @click="curId = 1">下一步</el-button>
          </div>
        </div>
        <div v-if="curId === 1">
          <div class="new_name" style="width: 100%;margin-bottom:10px;padding-bottom: 10px">主奖池   &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#F56C6C;margin-right:3px;">*</span>预计活动人数：
              <el-input v-model="formInline.active_number" placeholder="" style="width:100px;"></el-input>
              人
              <el-tooltip class="item" effect="dark" content="预估活动人数直接影响抽奖概率：中奖概率 = 奖品总数/(预估活动人数*每人每天最多抽奖次数*活动天数)" placement="right">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          <el-form :inline="false" class="acivity-prize-form">
            <div class="new-add-setting">
              奖品设置至少1个，至多6个
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addPrizeAction">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table :data="formInline.prize" border class="table" style="margin:0">
                <el-table-column label="奖品等级" width="90">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品类型" width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_type" placeholder="请选择">
                      <el-option v-for="item in prizeOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="奖品内容" width="220">
                  <template slot-scope="scope">
                    <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                      </el-input-number>
                      <span class="money-span">至</span>
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                      </el-input-number>
                    </div>
                    <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品编号"  min-width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 2">无需填写</span>
                    <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="start" label="奖品数量" width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="start" label="显示数量" width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num_show" class="prize-count" controls-position="right"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="start" width="120">
                  <template slot="header">
                    奖品图片
                    <el-tooltip class="item" effect="dark" content="建议尺寸100px*100px，大小500kb以内，格式为jpg,png" placement="right">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div style="position:relative">
                      <el-upload
                        class="avatar-uploader"
                        name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handlePrizeSuccess(res, file, scope.$index)}" :before-upload="beforeAvatarUpload">
                        <img v-if="scope.row.prize_img" :src="scope.row.prize_img" class="avatar">
                        <el-button size="small" type="primary" v-else style="margin-top:0">点击上传</el-button>
                        <i v-if="scope.row.prize_img" class="removeImg el-icon-circle-close-outline" @click="handlePrizeRemove('prize', scope.$index)" style="top: -9px;right: 15px"></i>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="deleteColor" style="font-size: 14px;font-style: normal" @click="deleteRow(scope.$index, formInline.prize)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name" style="width: 100%;margin:20px 0 10px 0;padding-bottom: 10px">助力奖池   &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#F56C6C;margin-right:3px;">*</span>预计活动人数：
              <el-input v-model="formInline.assistance_active_number" placeholder="" style="width:100px;"></el-input>
              人
              <el-tooltip class="item" effect="dark" content="预估活动人数直接影响抽奖概率：中奖概率 = 奖品总数/(预估活动人数*每人每天最多抽奖次数*活动天数)" placement="right">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="new-add-setting">
              <!-- <el-switch :active-value="1" :inactive-value="2" v-model="formInline.assistance_status" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch> -->
              邀请好友助力后，客户和助力好友后均在助力奖池中进行抽奖，奖品设置至少1个，至多6个
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addAssistancePrizeAction">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table :data="formInline.assistance_prize" border class="table" style="margin:0">
                <el-table-column label="奖品等级" width="90">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品类型" width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                      <el-option v-for="item in prizeOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="奖品内容" width="220">
                  <template slot-scope="scope">
                    <div v-if="scope.row.prize_type === 2" style="display: flex;justify-content: flex-start; flex-direction: row">
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_min_money" controls-position="right" :min="1">
                      </el-input-number>
                      <span class="money-span">至</span>
                      <el-input-number class="prize-count-special" v-model="scope.row.prize_max_money" controls-position="right" :min="1">
                      </el-input-number>
                    </div>
                    <el-input v-else v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品编号" min-width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 2">无需填写</span>
                    <el-input v-else v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="start" label="奖品数量" width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="start" label="显示数量" width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num_show" class="prize-count" controls-position="right"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="start" width="120">
                  <template slot="header">
                    奖品图片
                    <el-tooltip class="item" effect="dark" content="建议尺寸100px*100px，大小500kb以内，格式为jpg,png" placement="right">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <div style="position:relative">
                      <el-upload
                        class="avatar-uploader"
                        name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleAssistancePrizeSuccess(res, file, scope.$index)}" :before-upload="beforeAvatarUpload">
                        <img v-if="scope.row.prize_img" :src="scope.row.prize_img" class="avatar">
                        <el-button size="small" type="primary" v-else style="margin-top:0">点击上传</el-button>
                        <i v-if="scope.row.prize_img" class="removeImg el-icon-circle-close-outline" @click="handlePrizeRemove('assistance_prize', scope.$index)" style="top: -9px;right: 15px"></i>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="deleteColor" style="font-size: 14px;font-style: normal" @click="deleteAssistanceRow(scope.$index, formInline.assistance_prize)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-cancel-btn" style="margin-right: 10px;" @click="curId = 0">上一步</el-button>
              <el-button class="dialog-confirm-btn" type="primary" @click="curId = 2">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 2">
          <div class="new_name" style="width: 100%;">指定布奖次数 </div>
          <el-form :inline="false" class="acivity-prize-form">
            <div class="new-add-setting" style="display: flex; justify-content: flex-start; align-items: center;">
              指定第几次参与活动可获得指定奖励
              <el-switch style="margin-left: 10px; margin-right: 10px;" :active-value="1" :inactive-value="2" v-model="formInline.strategystate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px;" @click="addNumberAwards">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table :data="formInline.strategy" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="90">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="周期" min-width="170">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型">
                      <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.text">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="指定次数" min-width="170">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.specified_times" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="deleteColor" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name" style="width: 100%;" @click="prizeArea = !prizeArea">指定布奖区域 <i :class="{'el-icon-caret-bottom': !prizeArea, 'el-icon-caret-top': prizeArea}"></i> </div>
            <div class="new-add-setting" v-if="prizeArea" style="display: flex; justify-content: flex-start; align-items: center;">
              指定省市区县的中奖数量
              <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategyareastate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px; margin-left: 10px;" @click="addPrizeArea">新增</el-button>
            </div>
            <div class="new-add-table" v-if="prizeArea">
              <el-table :data="formInline.strategyarea" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="90">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="中奖区域" min-width="170">
                  <template slot-scope="scope">
                    <el-cascader size="large" :options="options" v-model="scope.row.region">
                    </el-cascader>
                  </template>
                </el-table-column>
                <el-table-column label="中奖数量" min-width="170">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column  min-width="150" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="deleteColor" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow4(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name"  style="width: 100%;" @click="timeSlot = !timeSlot">指定时间段布奖 <i :class="{'el-icon-caret-bottom': !timeSlot, 'el-icon-caret-top': timeSlot}"></i> </div>
            <div class="new-add-setting" v-if="timeSlot" style="display: flex; justify-content: flex-start; align-items: center;">
              指定每个时间段的中奖数量
              <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategytimestate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px; margin-left: 10px;" @click="addtimeSlotArea">新增</el-button>
            </div>
            <div class="new-add-table" v-if="timeSlot">
              <el-table :data="formInline.strategytime" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="110">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="周期" min-width="370">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型" style="width:120px;float:left">
                      <el-option v-for="item in cycleTimeOptions" :key="item.value" :label="item.label" :value="item.text">
                      </el-option>
                    </el-select>
                    <el-date-picker
                      v-if="scope.row.cycle_type === 'custom'"
                      v-model="scope.row.date"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerAppointedOptions"
                      style="width:225px;float:left;margin-left:8px;">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="时间段" min-width="250">
                  <template slot-scope="scope">
                    <el-time-picker
                      is-range
                      v-model="scope.row.time"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      placeholder="选择时间范围"
                      style="width:220px;">
                    </el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column label="数量" min-width="220">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow5(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name"  @click="prizeSlot = !prizeSlot"  style="width: 100%;">抽奖限制 <i :class="{'el-icon-caret-bottom': !prizeSlot, 'el-icon-caret-top': prizeSlot}"></i></div>
            <div v-if="prizeSlot">
              <el-form-item label-width="125px" label="总抽奖次数上限" style="text-align: left;" >
                <el-input-number v-model="formInline.draw_num" controls-position="right"  :min="1"></el-input-number>
              </el-form-item>
              <el-form-item  label-width="125px" label="单日抽奖次数上限" style="text-align: left;">
                <el-input-number v-model="formInline.everyday_draw_num" controls-position="right" :min="1"></el-input-number>
              </el-form-item>
              <el-form-item label-width="125px" label="中奖个数上限" style="text-align: left;">
                <el-input-number v-model="formInline.winning_prize_num" controls-position="right" :min="1"></el-input-number>
              </el-form-item>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="confirmSave">保存</el-button>
              <el-button class="dialog-cancel-btn" @click="curId = 1">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 3">
          <el-form :inline="false" class="acivity-prize-form">
            <div class="new_name">指定布奖次数 </div>
            <div class="new-add-setting">
              指定第几次参与活动可获得指定奖励
              <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategystate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px;float: none;" @click="addNumberAwards">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table :data="formInline.strategy" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="90">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="周期" min-width="170">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型">
                      <el-option v-for="item in cycleOptions" :key="item.value" :label="item.label" :value="item.text">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="指定次数" min-width="170">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.specified_times" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name"  style="width: 100%;" @click="prizeArea = !prizeArea">指定布奖区域 <i :class="{'el-icon-caret-bottom': !prizeArea, 'el-icon-caret-top': prizeArea}"></i> </div>
            <div class="new-add-setting" v-if="prizeArea">
              指定省市区县的中奖数量
              <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategyareastate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px;float: right" @click="addPrizeArea">新增</el-button>
            </div>
            <div class="new-add-table" v-if="prizeArea">
              <el-table :data="formInline.strategyarea" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="90">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="中奖区域" min-width="170">
                  <template slot-scope="scope">
                    <el-cascader size="large" :options="options" v-model="scope.row.region">
                    </el-cascader>
                  </template>
                </el-table-column>
                <el-table-column label="中奖数量" min-width="170">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column  min-width="150" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow4(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="new_name" @click="timeSlot = !timeSlot">指定时间段布奖 <i :class="{'el-icon-caret-bottom': !timeSlot, 'el-icon-caret-top': timeSlot}"></i> </div>
            <div class="new-add-setting" v-if="timeSlot">
              指定每个时间段的中奖数量
              <el-switch :active-value="1" :inactive-value="2" v-model="formInline.strategytimestate" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-button type="primary" style="margin-top: 3px;float: right" @click="addtimeSlotArea">新增</el-button>
            </div>
            <div class="new-add-table" v-if="timeSlot">
              <el-table :data="formInline.strategytime" border class="table" style="margin:0">
                <el-table-column label="奖品等级" min-width="110">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_level" placeholder="请选择奖品类型">
                      <el-option v-for="(item,index) in formInline.prize" :key="index" :label="level[index]" :value="(index + 1)">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="周期" min-width="370">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.cycle_type" placeholder="请选择奖品类型" style="width:120px;float:left">
                      <el-option v-for="item in cycleTimeOptions" :key="item.value" :label="item.label" :value="item.text">
                      </el-option>
                    </el-select>
                    <el-date-picker
                      v-if="scope.row.cycle_type === 'custom'"
                      v-model="scope.row.date"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerAppointedOptions"
                      style="width:225px;float:left;margin-left:8px;">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="时间段" min-width="250">
                  <template slot-scope="scope">
                    <el-time-picker
                      is-range
                      v-model="scope.row.time"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      placeholder="选择时间范围"
                      style="width:220px;">
                    </el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column label="数量" min-width="220">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.number" class="prize-count" controls-position="right" :min="1" style="width:180px;"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteStrategyRow5(scope.row)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addressShowFun">下一步</el-button>
              <el-button class="dialog-cancel-btn" @click="curId = 2">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog class="cellDialog base-dialog" title="指定次数发奖" :visible.sync="addActivityDialog" width="550px">
      <el-form ref="addForm" :rules="addFormRule" :model="addForm">
        <el-form-item label="选择奖项:" label-width="90px" prop="prize_level">
          <el-select v-model="addForm.prize_level" placeholder="请选择">
            <el-option
              v-for="item in formInline.prize"
              :key="item.prize_level"
              :label="item.level"
              :value="item.prize_level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择周期:" label-width="90px" prop="cycle_type">
          <el-select v-model="addForm.cycle_type" placeholder="请选择">
            <el-option
              v-for="item in lotteryPeriod"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间段:" label-width="90px" v-if="addForm.cycle_type === 'custom'">
          <el-date-picker
            v-model="date"
            @change="strategyDateChange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="奖励时机:" label-width="90px" prop="specified_times">
          <div style="display: flex;justify-content: flex-start; flex-direction: row">
            <el-input type="number" v-model="addForm.specified_times" :min="1" placeholder="请输入数字"></el-input>
          <el-tooltip class="item" effect="dark" content="第几次参与该活动可获得指定奖励" placement="right">
            <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
          </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="addActivityDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="submitAddForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog class="cellDialog base-dialog" title="指定次数发奖" :visible.sync="editActivityDialog" width="550px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="选择奖项:" label-width="90px">
          <el-select v-model="editForm.prize_level" placeholder="请选择">
            <el-option
              v-for="item in formInline.prize"
              :key="item.prize_level"
              :label="item.level"
              :value="item.prize_level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择周期:" label-width="90px">
          <el-select v-model="editForm.cycle_type" placeholder="请选择">
            <el-option
              v-for="item in lotteryPeriod"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择时间段:" label-width="90px" v-if="editForm.cycle_type === 'custom'">
          <el-date-picker
            v-model="date"
            @change="strategyDateChange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="奖励时机:" label-width="90px">
          <div style="display: flex;justify-content: flex-start; flex-direction: row">
            <el-input type="number" v-model="editForm.specified_times" :min="1" placeholder="请输入数字"></el-input>
          <el-tooltip class="item" effect="dark" content="第几次参与该活动可获得指定奖励" placement="right">
            <i class="el-icon-question" style="margin-top: 10px; margin-left: 5px;"></i>
          </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editActivityDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
import { createTreasureBoxActivity, getWechatPublicListForNode, getCustomerSourceListForWepage } from '@/api/customer.js'
export default {
  name: 'add-new-year-activity',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value) {
        return callback(new Error(''))
      }
    }
    return {
      sourceOptions: [
        {
          value: 1,
          label: '酒鬼酒业公众号'
        }
      ],
      prizeSlot: false,
      timeSlot: false,
      prizeArea: false,
      basicSenior: false,
      editActivityDialog: false,
      editForm: {},
      addForm: {
        cycle_type: '',
        prize_level: '',
        specified_times: ''
      },
      addActivityDialog: false,
      curId: 0,
      imageArray: [],
      options: regionDataPlus,
      date: [],
      sources: [],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      formInline: {
        strategyarea: [],
        active_number: 100,
        assistance_status: 2,
        share_description: '邀请好友一起参与',
        share_title: '分享赢大奖',
        draw_type: 1,
        sources: '来源说明',
        source_id: 1,
        textarea: '活动说明',
        name: '',
        time: ['2019-05-01 00:00:00', '2019-07-01 00:00:00'],
        start_time: 1556640000,
        source_content: '',
        end_time: 1561910400,
        draw_num: 1,
        everyday_draw_num: 1,
        winning_prize_num: 1,
        assistance_prize_num: 1,
        set_up: 1,
        receive_way: 1,
        wechat_share: 1,
        public_id: 1,
        cover_img: '',
        description: '',
        show_num: 0,
        strategy: [],
        assistance_prize: [
          {
            prize_level: 1,
            prize_type: 1,
            prize_name: '手机',
            prize_number: '',
            prize_num: '',
            probability: ''
          }
        ],
        prize: [
          {
            prize_level: '',
            prize_type: 1,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '1',
            prize_num: '1',
            probability: ''
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '20',
            prize_num: '10',
            probability: '',
            prize_min_money: 5,
            prize_max_money: 10
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '100',
            prize_num: '80',
            probability: '',
            prize_min_money: 1,
            prize_max_money: 5
          }
        ]
      },
      publicOptions: [],
      num8: 1,
      tableData: [
        {
          index: '1'
        }
      ],
      prizeOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '红包'
        }
      ],
      addFormRule: {
        prize_level: [
          { required: true, message: '请选择奖项', trigger: 'blur' }
        ],
        cycle_type: [
          { required: true, message: '请选择周期', trigger: 'blur' }
        ],
        specified_times: [
          { required: true, message: '请输入奖励时机', trigger: 'blur' }
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        source_content: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ],
        cover_img: [
          { required: true, message: '请输上传活动封面图', trigger: 'blur' }
        ]
      },
      everydayNumMax: 1,
      lotteryNumMax: 1,
      disable: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      lotteryPeriod: [
        {
          value: 'day',
          label: '每天'
        }
      ],
      cycleOptions: [{
        value: 1,
        text: 'day',
        label: '每天'
      },
      {
        value: 2,
        text: 'activityday',
        label: '活动期间'
      }],
      cycleTimeOptions: [{
        value: 1,
        text: 'day',
        label: '每天'
      },
      {
        value: 2,
        text: 'custom',
        label: '指定日期'
      }],
      prizeLevelOptions: [{
        value: 1,
        label: '一等奖'
      },
      {
        value: 2,
        label: '二等奖'
      }],
    }
  },
  methods: {
    handlePrizeRemove(name, index) {
      if (name === 'prize') {
        this.formInline.prize[index].prize_img = ''
      } else if (name === 'assistance_prize') {
        this.formInline.assistance_prize[index].prize_img = ''
      }
      event.stopPropagation()
    },
    confirmSave() {
      setTimeout(() => {
        _g.toastMsg('success', '保存成功')
        router.push({name: 'prizeActivity'})
      }, 500)
    },
    // 添加时间段布奖
    addtimeSlotArea() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.strategytime.push({
            prize_level: 1,
            cycle_type: 'day',
            date: [],
            time: ['', ''],
            begin_date: '',
            end_date: '',
            begin_time: '',
            end_time: '',
            number: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategytime.push({
            prize_level: 1,
            cycle_type: 'day',
            date: [],
            time: ['', ''],
            begin_date: '',
            end_date: '',
            begin_time: '',
            end_time: '',
            number: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    deleteStrategyRow4(item) {
      let index = this.formInline.strategyarea.indexOf(item)
      this.formInline.strategyarea.splice(index, 1)
    },
    deleteStrategyRow5(item) {
      let index = this.formInline.strategytime.indexOf(item)
      this.formInline.strategytime.splice(index, 1)
    },
    deleteRow(index, rows) {
      if (this.formInline.prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    deleteAssistanceRow(index, rows) {
      if (this.formInline.assistance_prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    // 添加中奖区域
    addPrizeArea() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          console.log(this.formInline)
          this.formInline.strategyarea.push({
            prize_level: 1,
            number: 1,
            region: [],
            province: '',
            city: '',
            district: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategyarea.push({
            prize_level: 1,
            number: 1,
            region: [],
            province: '',
            city: '',
            district: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    addNumberAwards() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.formInline.strategy.push({
            prize_level: 1,
            specified_times: 1,
            cycle_type: ''
          })
          return
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.formInline.strategy.push({
            prize_level: 1,
            specified_times: 1,
            cycle_type: ''
          })
          return
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    addressShowFun() {},
    assistanceStatusChange() {},
    wechatShareChange() {
    },
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    startOrStop(item) {
      if (item.status === 1) {
        item.status = 2
        _g.toastMsg('success', '停用成功')
      } else {
        item.status = 1
        _g.toastMsg('success', '启用成功')
      }
    },
    editRow(item) {
      this.editActivityDialog = true
      this.editForm = item
    },
    addStrategyActivityAction() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        if (this.formInline.prize[i].prize_name !== '' && this.formInline.prize[i].prize_type === 1) {
          this.addActivityDialog = true
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        } else if (this.formInline.prize[i].prize_min_money !== '' && this.formInline.prize[i].prize_type === 2) {
          this.addActivityDialog = true
          this.formInline.prize[i].prize_level = i + 1
          this.formInline.prize[i].level = this.level[i]
        } else {
          if (this.formInline.prize.length === 1) {
            _g.toastMsg('error', '请填全奖项')
            return
          }
        }
      }
    },
    // 编辑策略
    confirmEdit() {
      this.editActivityDialog = false
      this.editForm = {}
    },
    // 奖品 图片上传
    handlePrizeSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      _g.toastMsg('success', '上传成功')
      this.formInline.prize[index].prize_img = res.data.path
    },
    // 添加策略
    confirmAdd() {
      this.addActivityDialog = false
      for (let item of this.formInline.prize) {
        if (item.prize_level === this.addForm.prize_level) {
          this.addForm.prize_name = item.prize_name
        }
      }
      this.formInline.strategy.push({
        prize_level: this.addForm.prize_level,
        prize_name: this.addForm.prize_name,
        cycle_type: this.addForm.cycle_type,
        cycle_start: this.addForm.start_time,
        cycle_end: this.addForm.end_time,
        specified_times: this.addForm.specified_times,
        status: 1
      })
      this.addForm = {}
    },
    // 删除策略
    deleteStrategyRow(item) {
      let index = this.formInline.strategy.indexOf(item)
      this.formInline.strategy.splice(index, 1)
    },
    inputNumberChange(value) {
      this.everydayNumMax = this.formInline.draw_num
      this.lotteryNumMax = this.formInline.draw_num
    },
    addActivityAction() {
      if (this.disable === true) {
        _g.toastMsg('error', '请勿重复提交！')
        return
      }
      this.disable = true
      for (var i = 0; i < this.formInline.prize.length; i++) {
        this.formInline.prize[i].prize_level = i + 1
      }
      for (var j = 0; j < this.formInline.assistance_prize.length; j++) {
        this.formInline.assistance_prize[j].prize_level = j + 1
      }
      createTreasureBoxActivity(this.formInline).then(res => {
        this.disable = false
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/new-year-activity')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange() {
      this.formInline.start_time = this.date[0]
      this.formInline.end_time = this.date[1]
    },
    strategyDateChange() {
      this.addForm.start_time = this.date[0]
      this.addForm.end_time = this.date[1]
    },
    addPrizeAction() {
      if (this.formInline.prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: '',
        probability: ''
      })
    },
    addAssistancePrizeAction() {
      if (this.formInline.assistance_prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.assistance_prize.push({
        level: '',
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: '',
        probability: ''
      })
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.cover_img = res.data.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.publicOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 获取客户来源
    getSourceList() {
      getCustomerSourceListForWepage(1).then((res) => {
        if (res.data.code === 0) {
          this.sources = res.data.data.list
        }
      })
    }
  },
  components: {
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getPublicList()
    this.getSourceList()
    if (this.$route.query.id === '酒鬼湘泉布奖活动') {
      this.formInline = {
        strategyarea: [],
        strategytime: [],
        name: '酒鬼湘泉布奖活动',
        active_number: 100,
        assistance_status: 2,
        share_description: '邀请好友一起参与',
        share_title: '分享赢大奖',
        draw_type: 1,
        sources: '来源说明',
        source_id: 1,
        textarea: '活动说明',
        time: ['2019-05-01 00:00:00', '2019-07-01 00:00:00'],
        start_time: 1556640000,
        source_content: '',
        end_time: 1561910400,
        draw_num: 1,
        everyday_draw_num: 1,
        winning_prize_num: 1,
        assistance_prize_num: 1,
        set_up: 1,
        receive_way: 1,
        wechat_share: 1,
        public_id: 1,
        cover_img: '',
        description: '',
        show_num: 0,
        strategy: [],
        assistance_prize: [
          {
            prize_level: 1,
            prize_type: 1,
            prize_name: '手机',
            prize_number: '',
            prize_num: '',
            probability: ''
          }
        ],
        prize: [
          {
            prize_level: '',
            prize_type: 1,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '1',
            prize_num: '1',
            probability: ''
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '20',
            prize_num: '10',
            probability: '',
            prize_min_money: 5,
            prize_max_money: 10
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '100',
            prize_num: '89',
            probability: '',
            prize_min_money: 1,
            prize_max_money: 5
          }
        ]
      }
    }
    if (this.$route.query.id === '山东地区布奖活动') {
      this.formInline = {
        strategyarea: [],
        strategytime: [],
        active_number: 100,
        assistance_status: 2,
        share_description: '邀请好友一起参与',
        share_title: '分享赢大奖',
        draw_type: 1,
        sources: '来源说明',
        source_id: 1,
        textarea: '活动说明',
        name: '山东地区布奖活动',
        time: ['2019-05-01 00:00:00', '2019-07-01 00:00:00'],
        start_time: 1556640000,
        source_content: '',
        end_time: 1561910400,
        draw_num: 5,
        everyday_draw_num: 10,
        winning_prize_num: 10,
        assistance_prize_num: 1,
        set_up: 1,
        receive_way: 1,
        wechat_share: 1,
        public_id: 1,
        cover_img: '',
        description: '',
        show_num: 0,
        strategy: [],
        assistance_prize: [
          {
            prize_level: 1,
            prize_type: 1,
            prize_name: '手机',
            prize_number: '',
            prize_num: '',
            probability: ''
          }
        ],
        prize: [
          {
            prize_level: '',
            prize_type: 1,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '10',
            prize_num: '10',
            probability: ''
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '30',
            prize_num: '30',
            probability: '',
            prize_min_money: 5,
            prize_max_money: 10
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '手机',
            prize_number: '1001',
            prize_num_show: '60',
            prize_num: '60',
            probability: '',
            prize_min_money: 1,
            prize_max_money: 5
          }
        ]
      }
    }
    if (this.$route.query.id === '30-40岁男客户布奖') {
      this.formInline = {
        strategytime: [],
        strategyarea: [],
        active_number: 100,
        assistance_status: 2,
        share_description: '邀请好友一起参与',
        share_title: '分享赢大奖',
        draw_type: 1,
        sources: '来源说明',
        source_id: 1,
        textarea: '活动说明',
        name: '30-40岁男客户布奖',
        time: ['2019-05-03 01:00:00', '2019-07-01 00:00:00'],
        start_time: 1556640000,
        source_content: '',
        end_time: 1561910400,
        draw_num: 10,
        everyday_draw_num: 10,
        winning_prize_num: 5,
        assistance_prize_num: 1,
        set_up: 1,
        receive_way: 1,
        wechat_share: 1,
        public_id: 1,
        cover_img: '',
        description: '',
        show_num: 0,
        strategy: [],
        assistance_prize: [
          {
            prize_level: 1,
            prize_type: 2,
            prize_name: '',
            prize_number: '',
            prize_num: '1',
            probability: ''
          }
        ],
        prize: [
          {
            prize_level: '',
            prize_type: 1,
            prize_name: '头酒一瓶',
            prize_number: '1001',
            prize_num_show: '10',
            prize_num: '10',
            probability: ''
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '',
            prize_number: '1001',
            prize_num_show: '30',
            prize_num: '30',
            probability: '',
            prize_min_money: 3,
            prize_max_money: 10
          },
          {
            prize_level: '2',
            prize_type: 2,
            prize_name: '',
            prize_number: '',
            prize_num_show: '60',
            prize_num: '60',
            probability: '',
            prize_min_money: 1,
            prize_max_money: 5
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.create-acivity {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-left {
  width: 40%;
  height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
}
.acivity-right {
  width: 100%;
  /*height: 800px;*/
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: -30px;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 45px;
  height: 45px;
}
.mobile-img {
  position: absolute;
}
.scrol-image {
}
.liuhai{
  position: absolute;
  top: 113px;
  z-index: 100;
}
.scrol-image, .scrol-image .el-carousel__item  {
  height: 575px;
  width: 266px;
  border-radius: 26px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.tab-tit {
  width: 627px;
  margin: 90px auto 0;
  margin-bottom: 20px;
  overflow: hidden;
  margin-top: 20px;
}
.tab-tit .cur {
  color: #fff;
}
.tab-tit .line, .saveData .line {
  width:90%;
  margin: 2% auto;
  border:0.5px dashed #d2d2d2;
}
.tab-tit a {
  cursor: pointer;
  display:block;
  float: left;
  width: 130px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  color: #333;
  border: 1px solid #1890FF;
}
.acivity-content-form {
  width: 460px;
  text-align: left;
  margin: auto;
}
.acivity-setting-form {
  width: 460px;
  text-align: center;
  margin: auto;
}
.acivity-prize-form {
  /*text-align: center;*/
  /*margin: 0 auto;*/
  margin-top: -20px;
  width: 100%;
}
.acivity-content-form .el-form-item__content {
  width: 300px;
}
.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.prize-count {
  width: 100px;
}
.prize-count-special{
  width: 90px;
}
.prize-percent {
  width: 80px;
}
.prize-percent .el-input {
  width: 60px;
}
.prize-percent .el-input__inner {
  width: 60px;
  height: 36px;
}
.home-pic {
  width: 100%;
  height: 100%;
}
.avatar-pic {
  height:110px;
  width: 327px;
  display: block;
}
.button-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 20px;
}
.new-add-setting {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: left;
  margin-left: 0px;
  margin-top: 20px;
}
.new-add-table {
  width: 100%;
  margin-top: 10px;
}
.tags-text-item {
  width: 200px;
}
.tip-view {
  margin-left: 20px;
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  color: #666;
}
.money-span {
  display: block;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
}
@media screen and (min-width: 1600px) {
  .acivity-left {
    width: 35%;
    justify-content: flex-end;
    margin-right: 100px;
  }
  .mobile-img{
    right: -23px;
  }
  .liuhai{
    right: 60px;
  }
}
.basics-setting {
  width: 35%;
  margin: 0 auto;
  margin-bottom: 10px;
  text-align: left;
  font-size: 16px;
  color: #333;
  border-bottom: 1px dashed #dedede;
}
.setting-content {
  text-align: center;
}
.cover_img {
  border: 1px solid #d4d4d4;
  padding: 10px;
  border-radius: 5px;
}
.acivity-content-form .el-form-item__content {
  width: 300px;
}
.new_name{
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px dotted #D1D1D1;
  line-height: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  text-align: left;
}
.tab-tit .cur {
  color: #1980FF;
}

.tab-tit .line,
.saveData .line {
  width: 90%;
  margin: 2% auto;
  border: 0.5px dashed #d2d2d2;
}

.tab-tit a {
  cursor: pointer;
  display: block;
  float: left;
  width: 130px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  color: #333;
  border: 1px solid #1890FF;
}

.tab-tit ul {
  width: 800px;
  display: block;
  margin: 0 auto;
}
.tab-tit {
text-align: center;
}
.tab-tit ul li {
  list-style: none;
  float: left;
  width: 250px;
  height: 80px;
  position: relative;
  text-align: right;
  padding-top: 11px;
  box-sizing: border-box;
  cursor: pointer;
}

.tab-tit ul li img {
  width: 36px;
  margin-right: 5px;
}

.tab-tit ul li p {
  margin: 0;
  font-size: 12px;
  margin-top: 4px;
}

.tab-tit ul li span {
  position: absolute;
  display: inline-block;
  width: 205px;
  height: 1px;
  background: #C7C7C7;
  top: 30px;
  left: -4px;
}

.tab-tit ul li.cur span {
  background: #1980FF;
}

</style>
